import React, { createContext, useState, useEffect } from 'react';
import { fetchSwimmerData, fetchStandards } from '../utils/dataUtils';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [course, setCourse] = useState('SCY'); // SCY or LCM
  const [standard, setStandard] = useState('None'); // None, Junior Mets, Senior Mets
  const [searchQuery, setSearchQuery] = useState('');
  const [swimmers, setSwimmers] = useState({});
  const [standards, setStandards] = useState({
    juniorMets: [],
    seniorMets: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const jsonFile = course === 'SCY' ? '/data/swimmer_times_2425_Y.json' : '/data/swimmer_times_25_L.json';
        const juniorCsv = course === 'SCY' ? '/data/junior_mets_time_standards.csv' : '/data/junior_mets_time_standards_l.csv';
        const seniorCsv = course === 'SCY' ? '/data/senior_mets_time_standards.csv' : '/data/senior_mets_time_standards_l.csv';

        const swimmerData = await fetchSwimmerData(jsonFile);
        const juniorStandards = await fetchStandards(juniorCsv);
        const seniorStandards = await fetchStandards(seniorCsv);

        setSwimmers(swimmerData);
        setStandards({ juniorMets: juniorStandards, seniorMets: seniorStandards });
      } catch (err) {
        console.error('Error loading data:', err);
        setError('Failed to load swimmer data');
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [course]);

  return (
    <AppContext.Provider
      value={{
        course,
        setCourse,
        standard,
        setStandard,
        searchQuery,
        setSearchQuery,
        swimmers,
        standards,
        loading,
        error,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};